import { render, staticRenderFns } from "./SearchSorting.vue?vue&type=template&id=2823b282&scoped=true"
import script from "./SearchSorting.vue?vue&type=script&lang=ts"
export * from "./SearchSorting.vue?vue&type=script&lang=ts"
import style0 from "./SearchSorting.vue?vue&type=style&index=0&id=2823b282&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2823b282",
  null
  
)

export default component.exports